<template>
  <Badge
    :variant="variant"
    >
    {{ status.label }}
  </Badge>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { Badge } from "@/components/ui/badge/index.js";

const props = defineProps({
  status: {
    required: true,
  },
});

const variant = computed(() => {
  switch (props.status.value) {
    case 'validated':
      return 'green';
    case 'rejected':
      return 'red';
    case 'in_review':
      return 'yellow';
    case 'created':
    default:
      return 'zinc';
  }
});
</script>